/* LittleFeet Co. — direct card / PayPal checkout (theme side).
 * Prices, discounts and quantities always come from Shopify's own cart. The server
 * (Google Apps Script) re-reads the cart before creating the PayPal order, captures the
 * payment and creates the paid Shopify order. Card details never touch this site. */
(function () {
  'use strict';

  var fmt = function (cents, cur) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur || 'GBP' }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var getCart = function () {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  };
  var cartUpdate = function (body) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  };

  /* ---------- product page: "Pay by card or PayPal" ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lfdp-buy]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-lf-buybox]') || document;
    var form = scope.querySelector('form[data-ajax-product-form]') || scope.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    var qtyEl = form && form.querySelector('[name="quantity"]');
    var msg = btn.parentNode.querySelector('[data-lfdp-buy-msg]');
    if (!idEl || !idEl.value) return;
    var qty = Math.max(1, parseInt((qtyEl && qtyEl.value) || '1', 10) || 1);
    btn.disabled = true; btn.classList.add('is-loading');
    if (msg) msg.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idEl.value), quantity: qty }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to bag');
        window.location.href = btn.getAttribute('data-checkout-url') || '/pages/secure-checkout';
      })
      .catch(function (err) {
        if (msg) msg.textContent = err.message;
        btn.disabled = false; btn.classList.remove('is-loading');
      });
  });

  /* ---------- secure checkout page ---------- */
  function initCheckout(root) {
    var endpoint = root.getAttribute('data-endpoint');
    var clientId = root.getAttribute('data-client-id');
    var el = function (sel) { return root.querySelector(sel); };
    var linesEl = el('[data-lfdp-lines]'), totalsEl = el('[data-lfdp-totals]'), codesEl = el('[data-lfdp-codes]');
    var discForm = el('[data-lfdp-discount]'), discMsg = el('[data-lfdp-discount-msg]');
    var buttonsEl = el('[data-lfdp-buttons]'), msgEl = el('[data-lfdp-msg]'), payEl = el('[data-lfdp-pay]');
    var emptyEl = el('[data-lfdp-empty]'), busyEl = el('[data-lfdp-busy]');
    var current = null, busy = false, paidSnapshot = null, pending = null, btns = null, paypalNs = null;
    var sig = function (c) { return c.total_price + '|' + c.items.map(function (i) { return i.key + 'x' + i.quantity; }).join(','); };

    var setMsg = function (text, kind) {
      msgEl.textContent = text || '';
      msgEl.className = 'lfdp__msg' + (kind ? ' lfdp__msg--' + kind : '');
    };
    var setBusy = function (on, text) {
      busyEl.hidden = !on;
      if (on) busyEl.querySelector('span').textContent = text || 'Please wait…';
    };
    var post = function (data) {
      return fetch(endpoint, { method: 'POST', body: JSON.stringify(data), redirect: 'follow' })
        .then(function (r) { return r.json(); });
    };

    function render() {
      return getCart().then(function (cart) {
        current = cart;
        var cur = cart.currency;
        if (!cart.item_count) {
          root.classList.add('is-empty'); emptyEl.hidden = false; payEl.hidden = true;
          linesEl.innerHTML = ''; totalsEl.innerHTML = ''; return cart;
        }
        root.classList.remove('is-empty'); emptyEl.hidden = true; payEl.hidden = false;

        linesEl.innerHTML = cart.items.map(function (it) {
          var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="64" height="64">' : '<span class="lfdp__ph"></span>';
          var variant = it.variant_title && !/Default Title/.test(it.variant_title) ? '<span class="lfdp__variant">' + esc(it.variant_title) + '</span>' : '';
          var was = it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price, cur) + '</s> ' : '';
          return '<li class="lfdp__line" data-key="' + esc(it.key) + '">' + img +
            '<span class="lfdp__name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
            '<span class="lfdp__stepper"><button type="button" data-lfdp-qty="-1" aria-label="Decrease quantity">−</button>' +
            '<span>' + it.quantity + '</span><button type="button" data-lfdp-qty="1" aria-label="Increase quantity">+</button>' +
            '<button type="button" class="lfdp__rm" data-lfdp-qty="remove">Remove</button></span></span>' +
            '<span class="lfdp__price">' + was + fmt(it.final_line_price, cur) + '</span></li>';
        }).join('');

        var codes = (cart.discount_codes || []);
        codesEl.innerHTML = codes.map(function (d) {
          return '<span class="lfdp__chip' + (d.applicable ? '' : ' is-bad') + '">' + esc(d.code) +
            (d.applicable ? '' : ' (not valid for this bag)') +
            ' <button type="button" data-lfdp-remove="' + esc(d.code) + '" aria-label="Remove ' + esc(d.code) + '">×</button></span>';
        }).join('');

        var rows = [['Items', fmt(cart.original_total_price, cur)]];
        if (cart.total_discount > 0) rows.push(['Discount', '−' + fmt(cart.total_discount, cur)]);
        rows.push(['Delivery', 'Free (UK)']);
        if (cart.total_price <= 0) setMsg('This bag has nothing to pay. Please use the normal checkout from your bag.', 'error');
        totalsEl.innerHTML = rows.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>'; }).join('') +
          '<div class="lfdp__grand"><dt>Total</dt><dd>' + fmt(cart.total_price, cur) + '</dd></div>';
        if (pending && pending !== sig(cart)) resetButtons('Your bag changed, so the payment form was reset — please enter your payment again.');
        return cart;
      });
    }

    discForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = discForm.querySelector('input');
      var code = (input.value || '').trim();
      if (!code) return;
      var existing = (current && current.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      if (existing.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) < 0) existing.push(code);
      discMsg.textContent = 'Checking…';
      cartUpdate({ discount: existing.join(',') }).then(render).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        discMsg.textContent = hit && hit.applicable ? 'Discount applied.' : 'That code can’t be used with this bag.';
        if (hit && hit.applicable) input.value = '';
      }).catch(function () { discMsg.textContent = 'Couldn’t check that code — please try again.'; });
    });

    codesEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lfdp-remove]');
      if (!b) return;
      var drop = b.getAttribute('data-lfdp-remove').toLowerCase();
      var keep = (current.discount_codes || []).filter(function (d) { return d.applicable && d.code.toLowerCase() !== drop; }).map(function (d) { return d.code; });
      cartUpdate({ discount: keep.join(',') }).then(render);
    });

    linesEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lfdp-qty]');
      if (!b || busy) return;
      var li = b.closest('[data-key]');
      var item = (current.items || []).filter(function (i) { return i.key === li.getAttribute('data-key'); })[0];
      if (!item) return;
      var v = b.getAttribute('data-lfdp-qty');
      var qty = v === 'remove' ? 0 : Math.max(0, item.quantity + parseInt(v, 10));
      busy = true; li.style.opacity = '.5';
      fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: qty }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) setMsg((j && j.description) || 'Not enough stock for that quantity.', 'error'); }); })
        .catch(function () {}).then(function () { busy = false; return render(); });
    });

    // keep the summary true to the bag: returning to the tab, the back button (bfcache),
    // or the bag changing in another tab all trigger a fresh read
    document.addEventListener('visibilitychange', function () { if (!document.hidden && !busy) render(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) render(); });
    window.addEventListener('focus', function () { if (!busy) render(); });

    function loadSdk() {
      return new Promise(function (resolve, reject) {
        if (window.paypal && window.paypal.Buttons) return resolve(window.paypal);
        var s = document.createElement('script');
        s.src = 'https://www.paypal.com/sdk/js?client-id=' + encodeURIComponent(clientId) +
          '&currency=GBP&intent=capture&components=buttons&enable-funding=card&disable-funding=venmo&locale=en_GB';
        s.setAttribute('data-page-type', 'checkout');
        s.onload = function () { resolve(window.paypal); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    // After payment, take out only what was paid for, so items added in another tab stay in the bag
    function removePaidItems() {
      if (!paidSnapshot) return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
      return getCart().then(function (cart) {
        var updates = {};
        paidSnapshot.forEach(function (p) {
          var line = cart.items.filter(function (i) { return i.key === p.key || i.variant_id === p.variant; })[0];
          if (line) updates[line.key] = Math.max(0, line.quantity - p.qty);
        });
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
      });
    }

    // Rebuild PayPal's buttons/card form so a half-finished payment can never be for an old bag
    function resetButtons(note) {
      pending = null; paidSnapshot = null;
      if (!btns || !paypalNs) return;
      var old = btns; btns = null;
      Promise.resolve(old.close && old.close()).catch(function () {}).then(function () {
        buttonsEl.innerHTML = '';
        btns = makeButtons(paypalNs); btns.render(buttonsEl);
        if (note) setMsg(note);
      });
    }

    var errorText = function (r) {
      switch (r && r.error) {
        case 'empty_cart': return 'Your bag is empty.';
        case 'unavailable': return (r.item || 'An item') + ' has just sold out — please remove it from your bag.';
        default: return 'We couldn’t start the payment. Nothing has been charged — please try again in a moment.';
      }
    };

    function makeButtons(paypal) {
      return paypal.Buttons({
        style: { layout: 'vertical', shape: 'pill', color: 'gold', label: 'pay', height: 48 },
        createOrder: function () {
          setMsg('');
          busy = true; pending = null;
          return render().then(function (cart) {
            if (!cart.item_count) { setMsg('Your bag is empty.', 'error'); throw new Error('empty'); }
            if (cart.total_price <= 0) throw new Error('zero');
            paidSnapshot = cart.items.map(function (i) { return { key: i.key, variant: i.variant_id, qty: i.quantity }; });
            pending = sig(cart);
            return post({ action: 'create', cartToken: cart.token });
          }).then(function (r) {
            busy = false;
            if (!r.ok) { setMsg(errorText(r), 'error'); throw new Error(r.error); }
            return r.id;
          }, function (err) { busy = false; throw err; });
        },
        onApprove: function (data, actions) {
          busy = true;
          setBusy(true, 'Confirming your payment…');
          var tries = 0;
          var capture = function () {
            return post({ action: 'capture', orderID: data.orderID }).catch(function (err) {
              if (++tries < 3) return new Promise(function (ok) { setTimeout(ok, 1500 * tries); }).then(capture);
              throw err;
            });
          };
          return capture().then(function (r) {
            if (r.restart) { pending = null; busy = false; setBusy(false); setMsg('Your card was declined — please try another card.', 'error'); return actions.restart(); }
            if (!r.ok) {
              busy = false; setBusy(false);
              setMsg('We couldn’t confirm this payment automatically. Please don’t pay again — email info@littlefeetco.com quoting ' + data.orderID + ' and we’ll sort it out straight away.', 'error');
              return;
            }
            return removePaidItems().catch(function () {}).then(function () {
              if (r.statusUrl) { window.location.href = r.statusUrl; return; }
              setBusy(false);
              root.innerHTML = '<div class="lfdp__done"><h2>Thank you — payment received</h2><p>' +
                esc(r.message || ('Your order ' + (r.orderName || '') + ' is confirmed. A confirmation email is on its way.')) + '</p><a class="button button--primary" href="/">Continue shopping</a></div>';
            });
          }).catch(function () {
            busy = false; setBusy(false);
            setMsg('Connection problem while confirming. Please don’t pay again — email info@littlefeetco.com quoting ' + data.orderID + '.', 'error');
          });
        },
        onShippingAddressChange: function (d, actions) {
          var cc = d && d.shippingAddress && d.shippingAddress.countryCode;
          if (cc && cc !== 'GB') return actions.reject(d.errors && d.errors.COUNTRY_ERROR);
        },
        onCancel: function () { pending = null; busy = false; render(); setMsg('Payment cancelled — you haven’t been charged.'); },
        onError: function () { pending = null; busy = false; setBusy(false); render(); if (!msgEl.textContent) setMsg('Something went wrong with the payment window. Nothing has been charged — please try again.', 'error'); }
      });
    }

    render().then(function () { return loadSdk(); }).then(function (paypal) {
      paypalNs = paypal;
      btns = makeButtons(paypal);
      return btns.render(buttonsEl);
    }).catch(function () {
      setMsg('The payment buttons couldn’t load. Please refresh the page, or use the normal checkout from your bag.', 'error');
    });
  }

  var start = function () {
    var root = document.querySelector('[data-lfdp-checkout]');
    if (root) initCheckout(root);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* cart page: save any quantity edits, then go to the secure checkout */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-lfdp-cart-go]');
  if (!b) return;
  e.preventDefault();
  var form = b.closest('form');
  var go = function () { window.location.href = b.getAttribute('data-url') || '/pages/secure-checkout'; };
  if (!form) return go();
  b.disabled = true;
  var fd = new FormData(form);
  var body = new URLSearchParams();
  fd.forEach(function (v, k) { if (k === 'updates[]' || k === 'note') body.append(k, v); });
  fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' }, body: body.toString() })
    .catch(function () {}).then(go);
});

/* product page: move the button (rendered at the end of the page) under the Add to cart form */
(function () {
  var place = function () {
    var mount = document.querySelector('[data-lfdp-mount]');
    if (!mount) return;
    var form = document.querySelector('[data-lf-buybox] form[data-ajax-product-form]') || document.querySelector('form[action*="/cart/add"]');
    if (form && form.parentNode) form.parentNode.insertBefore(mount, form.nextSibling);
    mount.hidden = false;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();

/* back/forward cache: coming back with the browser's Back button must never show a stale bag
   or a button stuck on "loading" */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  document.querySelectorAll('[data-lfdp-buy],[data-lfdp-cart-go]').forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
  if (document.querySelector('[data-lfdp-cart-go]') && /\/cart\/?$/.test(location.pathname)) location.reload();
});
